// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3k0sE","inner":"Footer_inner__3CGlO"};